"use client";

import Carousel from "./components/Carousel";
import Footer from "./components/Footer";

import { FiTruck, FiTool, FiDroplet, FiLayers, FiMapPin } from "react-icons/fi";

import { MdOutlineEngineering } from "react-icons/md";

export default function HomePage() {
  return (
    <main className="bg-gray-50 text-gray-800 overflow-hidden">
      {/* HERO */}
      <Carousel />

      {/* PRODUCTOS */}
      <section className="mt-[-50px] max-w-7xl mx-auto py-20 px-4">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-green-800">
            Productos <span className="text-yellow-500">Destacados</span>
          </h2>

          <p className="text-gray-500 mt-5 max-w-2xl mx-auto">
            Soluciones innovadoras y productos de alta calidad para optimizar el
            rendimiento agrícola.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 sm:gap-8 mt-8">
          {[
            {
              img: "/images/implementos.png",
              color: "#007d00",
            },
            {
              img: "/images/ferreteria.png",
              color: "#eb7d02",
            },
            {
              img: "/images/maquinaria2.png",
              color: "#f4d700",
            },
            {
              img: "/images/carriego2.png",
              color: "#124395",
            },
            {
              img: "/images/pecuarios.png",
              color: "#6bc6db",
            },
            {
              img: "/images/fuentes.png",
              color: "#617d8b",
            },
            {
              img: "/images/jardineria.png",
              color: "#c46a4a",
            },
            {
              img: "/images/indimentaria.png",
              color: "#bbb6dc",
            },
          ].map((p, i) => (
            <div
              key={i}
              className="
          group
          bg-white rounded-3xl
          overflow-hidden
          shadow-md hover:shadow-2xl
          transition-all duration-500
          hover:-translate-y-2
          flex flex-col justify-between
        "
            >
              <div>
                <div className="relative overflow-hidden h-32 sm:h-48">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="
                w-full h-full object-cover
                group-hover:scale-110
                transition-transform duration-700
              "
                  />
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition" />
                </div>

                <div
                  className="border-t-4 transition-all duration-500"
                  style={{ borderColor: p.color }}
                />
              </div>

              <div className="p-2 text-center flex flex-col justify-between flex-grow">
                <button
                  className="
              mt-5 w-full sm:w-auto mx-auto
              bg-green-700 hover:bg-green-800
              text-white text-sm font-semibold
              px-5 py-2 rounded-xl
              transition-colors duration-300
            "
                >
                  Ver Más
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* IMPORTADORES */}
      <section className="relative py-5 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-green-800 to-green-600" />

        <div className="absolute top-0 left-0 w-62 h-62 bg-yellow-400/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-62 h-62 bg-white/10 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-5">
          <div className="text-center mb-5">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">
              Somos{" "}
              <span className="text-yellow-300">Importadores Directos</span>
            </h2>

            <p className="text-green-100 mt-5 max-w-2xl mx-auto">
              Trabajamos con productos agrícolas de alta tecnología,
              garantizando calidad, resistencia y mejores precios.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* CARD 1 */}
            <div
              className="
                bg-white/10 backdrop-blur-xl
                border border-white/20
                rounded-3xl
                p-6
                shadow-2xl
                hover:scale-[1.02]
                transition-all duration-500
                flex items-center gap-5
              "
            >
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white p-3 text-center">
                  Máquinaria
                </h3>
                <div className="flex justify-center items-center">
                  <img
                    src="/images/maquifum.png"
                    className="
                  w-25 h-25 sm:w-35 sm:h-35
                  rounded-2xl
                  object-cover
                  shadow-2xl content-center
                "
                  />
                </div>

                <p className="text-green-100 mt-8 leading-relaxed text-center">
                  Importamos maquinaria de alta gama bajo estrictos estándares
                  de calidad.
                </p>
                <div className="text-center">
                  <button
                    className="
                    mt-5
                    bg-yellow-400 hover:bg-yellow-300
                    text-black
                    px-5 py-2 rounded-xl
                    font-semibold
                    transition 
                  "
                  >
                    Más Información
                  </button>
                </div>
              </div>
            </div>

            {/* CARD 2 */}
            <div
              className="
                bg-white rounded-3xl
                p-6
                shadow-2xl
                hover:scale-[1.02]
                transition-all duration-500
                flex items-center gap-5
              "
            >
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-green-800 p-3 text-center">
                  Plástico
                </h3>

                <div className="flex justify-center items-center">
                  <img
                    src="/images/plasticoinv.png"
                    className="
                  w-25 h-25 sm:w-35 sm:h-35
                  rounded-2xl
                  object-cover
                  shadow-2xl content-center
                "
                  />
                </div>

                <p className="text-gray-8 mt-8 leading-relaxed text-center">
                  Protección avanzada para cultivos con tecnología europea y
                  alta durabilidad.
                </p>

                <div className="text-center">
                  <button
                    className="
                    mt-5
                    bg-green-700 hover:bg-green-800
                    text-white
                    px-5 py-2 rounded-xl
                    font-semibold
                    transition
                  "
                  >
                    Más Información
                  </button>
                </div>
              </div>
            </div>

            <div
              className="
                bg-white/10 backdrop-blur-xl
                border border-white/20
                rounded-3xl
                p-6
                shadow-2xl
                hover:scale-[1.02]
                transition-all duration-500
                flex items-center gap-5
              "
            >
              <div className="flex-1">
                <h3 className="text-2xl p-3 font-bold text-white text-center">
                  Cable acerado
                </h3>
                <div className="flex justify-center items-center">
                  <img
                    src="/images/cablesss.png"
                    className="
                  w-25 h-25 sm:w-35 sm:h-35
                  rounded-2xl
                  object-cover
                  shadow-2xl content-center
                "
                  />
                </div>
                <p className="text-green-100 mt-8 leading-relaxed text-center">
                  Maximiza la vida de tu invernadero con nuestro Cable Acerado
                  con Forro Azul
                </p>

                <div className="text-center">
                  <button
                    className="
                    mt-5
                    bg-yellow-400 hover:bg-yellow-300
                    text-black
                    px-5 py-2 rounded-xl
                    font-semibold
                    transition
                  "
                  >
                    Más Información
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICIOS */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-extrabold text-green-800">
              Servicios <span className="text-yellow-500">Valedmo</span>
            </h2>

            <p className="text-gray-500 mt-5">
              Soluciones completas para el sector agrícola.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-6 gap-6">
            {[
              { Icon: MdOutlineEngineering, title: "Asesoría Personalizada" },
              { Icon: FiMapPin, title: "Asesoría en Campo" },
              { Icon: FiTool, title: "Servicio Técnico" },
              { Icon: FiTruck, title: "Entrega Nacional" },
              { Icon: FiLayers, title: "Instalación de Geomembrana" },
              { Icon: FiDroplet, title: "Instalación de Riego" },
            ].map((item, i) => (
              <div
                key={i}
                className="
                  bg-gray-50
                  rounded-3xl
                  p-3
                  text-center
                  shadow-md
                  hover:shadow-2xl
                  hover:-translate-y-2
                  transition-all duration-500
                  group
                "
              >
                <item.Icon
                  className="
                    mx-auto text-5xl text-green-700
                    group-hover:scale-110
                    transition-transform duration-300
                  "
                />

                <h2 className="mt-5 font-bold text-sm">{item.title}</h2>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECCIÓN VIDEOS */}
      <section className="py-1 bg-gradient-to-b from-white to-gray-100 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {/* VIDEO 1 */}
            <div
              className="
          bg-white
          rounded-3xl
          overflow-hidden
          shadow-xl
          hover:shadow-2xl
          transition-all duration-500
          hover:-translate-y-2
          group
        "
            >
              <div className="relative h-[260px] md:h-[320px] overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/S5plFJBcrKo"
                  title="Video Valedmo 1"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="
              w-full h-full
              group-hover:scale-[1.02]
              transition-transform duration-500
            "
                />

                <div
                  className="
              absolute inset-0
              bg-gradient-to-t
              from-black/40 to-transparent
              pointer-events-none
            "
                />
              </div>

              <div className="p-2">
                <div className="flex items-center justify-between">
                  <h3 className="text-xl font-bold text-green-800">
                    Plásticos para Invernadero
                  </h3>
                </div>

                <p className="text-gray-500 text-sm mt-3 leading-relaxed">
                  ¡Dale a tus cultivos la seguridad que merecen!. Cultiva con
                  plásticos 100% europeos de alta durabilidad y protección
                  avanzada.
                </p>
              </div>
            </div>

            {/* VIDEO 2 */}
            <div
              className="
          bg-white
          rounded-3xl
          overflow-hidden
          shadow-xl
          hover:shadow-2xl
          transition-all duration-500
          hover:-translate-y-2
          group
        "
            >
              <div className="relative h-[260px] md:h-[320px] overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/fnVImbHjjNU"
                  title="Video Valedmo 2"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="
              w-full h-full
              group-hover:scale-[1.02]
              transition-transform duration-500
            "
                />

                <div
                  className="
              absolute inset-0
              bg-gradient-to-t
              from-black/40 to-transparent
              pointer-events-none
            "
                />
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-xl font-bold text-green-800">
                    Cinta Poy Repair
                  </h3>
                </div>

                <p className="text-gray-500 text-sm mt-3 leading-relaxed">
                  Solución eficaz para el sellado y parchado inmediato de
                  cubiertas plásticas en invernaderos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <a
        href="https://wa.me/593995149001?text=Hola%20Valedmo,%20necesito%20más%20información%20sobre%20sus%20productos%20y%20servicios%20que%20revise%20en%20su%20página%20web."
        target="_blank"
        rel="noopener noreferrer"
        className="
        fixed bottom-5 right-4 sm:bottom-6 sm:right-6 z-50 flex items-end gap-3 group"
      >
        {/* CHAT */}
        <div
          className="
            hidden sm:flex
            bg-white rounded-2xl
            shadow-2xl
            px-5 py-3
            border border-gray-100
            relative
            animate-pulse
          "
        >
          <div>
            <p className="text-sm font-bold text-green-800">Somos Valedmo 👋</p>

            <p className="text-xs text-gray-600 mt-1">
              ¿En qué podemos ayudarte?
            </p>
          </div>

          <div
            className="
              absolute -right-2 bottom-4
              w-4 h-4
              bg-white rotate-45
              border-r border-b border-gray-100
            "
          />
        </div>

        {/* BOTÓN */}
        <div
          className="
            relative
            w-16 h-16 sm:w-20 sm:h-20
            rounded-full
            overflow-hidden
            border-4 border-white
            shadow-2xl
            bg-white
            group-hover:scale-110
            transition-all duration-300
          "
        >
          <img
            src="/images/chat.png"
            alt="WhatsApp Valedmo"
            className="w-full h-full object-cover"
          />

          {/* ONLINE */}
          <span
            className="
              absolute bottom-1 right-1
              w-4 h-4
              bg-green-500
              border-2 border-white
              rounded-full
            "
          />

          {/* PULSE */}
          <span
            className="
              absolute inset-0
              rounded-full
              bg-green-400/20
              animate-ping
            "
          />
        </div>
      </a>

      <Footer />
    </main>
  );
}
